import { Button, Modal, Space, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startCargaComprobantePagoXLSX } from "../../../../../context/actions/pagos2Actions";

export default function ModalCargarXLSXPago({ visible, onClose, ordenPagoID, onSuccess }) {
  const dispatch = useDispatch();
  const [error, setError] = useState({});
  const [file, setFile] = useState();
  const [uploading, setUploading] = useState(false);

  const usuarioId = useSelector(state => state.userReducer.user.usuarioID);

  function beforeUpload(file) {
    setFile(file);
    return false;
  }

  async function uploadFile() {
    if (!file) {
      setError({ error: true, message: "Por favor seleccione un archivo" });
      return;
    }

    setUploading(true);

    try {
      const fileForm = new FormData();
      fileForm.append('file', file);
      fileForm.append('usuarioId', usuarioId);
      fileForm.append('ordenPagoID', ordenPagoID);

      const result = await dispatch(startCargaComprobantePagoXLSX(fileForm));

      if (result.success) {
        setError({ error: false, message: "Archivo cargado correctamente" });
        setFile(null);

        if (onSuccess) {
          setTimeout(() => {
            onSuccess();
          }, 1000);
        }
      } else {
        setError({ error: true, message: 'Error al cargar el archivo' });
      }
    } finally {
      setUploading(false);
    }
  }

  const handleClose = () => {
    setFile(null);
    setError({});
    onClose();
  };

  return (
    <>
      <Modal
        title="Cargar archivo xlsx"
        open={visible}
        onCancel={handleClose}
        footer={null}
        wrapClassName="pagos-v2-modal"
      >
        <div style={{ height: "200px" }}>
          <Space
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
              alignItems: "flex-start"
            }}
          >
            <Upload
              maxCount={1}
              accept='text/xlsx'
              onRemove={() => {
                setFile(null);
                setError({});
              }}
              beforeUpload={beforeUpload}
            >
              <Button
                type='primary'
                icon={<UploadOutlined />}
              >
                Seleccione un archivo
              </Button>
            </Upload>

            <Button
              onClick={uploadFile}
              icon={<UploadOutlined />}
              loading={uploading}
              disabled={!file}
            >
              Subir Archivo
            </Button>
          </Space>

          <span
            style={{
              color: error.error ? "red" : 'green',
              display: "flex",
              justifyContent: "center",
              marginBottom: "10px",
              marginTop: "80px",
              fontSize: "20px"
            }}
          >
            {error.message}
          </span>
        </div>
      </Modal>
    </>
  );
}
